import { render } from "./footwearDetail.vue?vue&type=template&id=78cd4e37&ts=true"
import script from "./footwearDetail.vue?vue&type=script&lang=ts"
export * from "./footwearDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__